import { Box, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import styles from "./styles";

const ContactListItem = ({
  isActive,
  text,
  isPaywall = false,
}: {
  isActive: boolean;
  isPaywall?: boolean;
  text: string;
}) => {
  return (
    <ListItem disablePadding>
      <ListItemIcon sx={[isActive ? styles.checkActive : styles.checkInactive]}>
        <Box component="span" className="fa-regular fa-circle-check" />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          sx: [
            !isActive && styles.scoreListItemInactive,
            isPaywall && { fontStyle: "italic" },
          ],
        }}
        primary={text}
      />
    </ListItem>
  );
};

export default ContactListItem;
